import { formatUtils } from "@/utils";

export const formatDataForTopProducts = (
  data: Array<Dic<any>>,
  locale: string = "fr",
  currency: string = "EUR"
) => {
  return data.map((item: Dic<any>) => ({
    id: item?.id,
    name: item?.item?.name ?? "",
    displays: item?.displays,
    clickThroughRate: formatUtils.formatToPercent(
      item?.goToPageUsages / (item?.displays ?? 1),
      2,
      locale
    ),
    addToCartRate: formatUtils.formatToPercent(
      item?.addToCartUsages / (item?.displays ?? 1),
      2,
      locale
    ),
    revenue: formatUtils.formatCurrency(item?.revenues ?? 0, locale, currency),
  }));
};
